const getNiceIntervals = val => {
  let result = 1;

  while (val / 10 >= 1) {
    result = result * 10;
    val = Math.ceil(val / 10);
  }

  if (val < 7) result = result / 2;

  return result;
};

export const getInterval = val => {
  switch (true) {
    case val > 120:
      return getNiceIntervals(val);
    case val > 80:
      return 20;
    case val > 40:
      return 10;
    case val > 14:
      return 5;
    case val > 6:
      return 2;
    default:
      return 1;
  }
};

export const getChartMax = (dataMax, interval) => {
  let runningMax = Math.ceil(dataMax) + 1;

  while (runningMax % interval !== 0) {
    runningMax++;
  }

  return runningMax;
};
